module.exports = __webpack_public_path__ + "img/shrines-1-640.fa3a97b5.jpg";